import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

/**
 * Gera uma sequência aleatória de 16 letras
 * @returns {string}
 */
export const randomId = () => {
	return uuidv4();
};

export const useRandomIds = () => {
	const [ids, setIds] = useState({});

	return (key) => (key in ids ? ids[key] : setIds((oldIds) => ({ ...oldIds, [key]: `${key}:${randomId()}` })));
};
